import { apiJson } from "./client";

/** @param {{ q?: string, take?: number }} query */
export function getUserSuggestions(query) {
  return apiJson("/api/Users/suggestions", { method: "GET", query });
}

/** @param {number} userId */
export function getChatPeer(userId) {
  return apiJson(`/api/Users/${userId}/chat-peer`, { method: "GET" });
}
